import styled, { createGlobalStyle } from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

export const GlobalStyle = createGlobalStyle`
  :root {
    --segfy-color-black: #807973;
    --segfy-color-darkgrey: #b1aba6;
    --segfy-color-grey: #dedede;
    --segfy-color-lightgrey: #f1f3f4;
    --segfy-color-accent: #faf7f2;
    --segfy-color-red: #d25032;
    --segfy-color-lightred: #f2937e;
    --segfy-color-orange: #f4ad4b;
    --segfy-color-lime: #e2ed8d;
    --segfy-color-green: #69c782;
    --segfy-color-lightgreen: #c8f2d3;
    --segfy-color-cyan: #8deddb;
    --segfy-color-lightblue: #b1dff0;
    --segfy-color-white: #ffffff;

    /* Design tokens — nova identidade da tela de login */
    --auth-bg-cream: #FBF8F4;
    --auth-bg-ink: #14110D;
    --auth-text-primary: #181410;
    --auth-text-secondary: #5C544A;
    --auth-text-on-dark: #B8AFA3;
    --auth-text-perk: #E8E2D8;
    --auth-text-footer: #8A8276;
    --auth-accent: #FF7A00;
    --auth-accent-on-dark: #FF9A40;
    --auth-label: #34302A;
    --auth-placeholder: #A79E92;
    --auth-input-border: #E2DACF;
    --auth-card-border: #ECE5DC;
    --auth-link: #C85800;
    --auth-link-hover: #FF7A00;
    --auth-soft-tint: #FFEFE0;
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: 'Hanken Grotesk', 'Open Sans', sans-serif;
    font-size: 12px;
    color: var(--auth-text-primary);
    background: var(--auth-bg-cream);
    height: 100vh;
    -webkit-font-smoothing: antialiased;
  }

  ::selection {
    background: var(--auth-accent);
    color: #fff;
  }

  #rootLogin {
    height: 100%;
  }

  /* ==========================================================================
     Banner de consentimento de cookies (HubSpot) — restilizado para a nova
     identidade. O HTML é injetado pelo embed do HubSpot (IDs fixos), então
     sobrescrevemos o CSS aqui usando os mesmos tokens da tela de login.
     ========================================================================== */
  #hs-eu-cookie-confirmation.hs-cookie-notification-position-bottom {
    background: #fff !important;
    border: none !important;
    border-top: 1px solid var(--auth-card-border) !important;
    box-shadow: 0 -10px 34px rgba(20, 17, 13, 0.08) !important;
    font-family: 'Hanken Grotesk', 'Open Sans', sans-serif !important;
    padding: 0 !important;
  }

  #hs-eu-cookie-confirmation #hs-eu-cookie-confirmation-inner {
    max-width: 1080px;
    margin: 0 auto !important;
    padding: 22px 40px !important;
    background: transparent !important;
    color: var(--auth-text-secondary) !important;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  #hs-eu-cookie-confirmation #hs-eu-policy-wording,
  #hs-eu-cookie-confirmation #hs-eu-policy-wording p,
  #hs-eu-cookie-confirmation #hs-eu-cookie-disclaimer {
    color: var(--auth-text-secondary) !important;
    font-family: inherit !important;
    font-size: 13px !important;
    line-height: 1.55 !important;
    margin: 0 !important;
  }

  #hs-eu-cookie-confirmation #hs-eu-cookie-disclaimer {
    font-size: 12.5px !important;
    color: #7a7268 !important;
    margin-top: 6px !important;
  }

  #hs-eu-cookie-confirmation #hs-eu-policy-wording a {
    color: var(--auth-link) !important;
    font-weight: 600 !important;
    text-decoration: none !important;
  }

  #hs-eu-cookie-confirmation #hs-eu-policy-wording a:hover {
    color: var(--auth-link-hover) !important;
    text-decoration: underline !important;
  }

  #hs-eu-cookie-confirmation #hs-en-cookie-confirmation-buttons-area {
    margin-top: 14px !important;
  }

  #hs-eu-cookie-confirmation #hs-eu-cookie-confirmation-button-group {
    display: flex !important;
    flex-wrap: wrap;
    gap: 12px !important;
  }

  #hs-eu-cookie-confirmation a#hs-eu-confirmation-button,
  #hs-eu-cookie-confirmation a#hs-eu-decline-button {
    margin: 0 !important;
    padding: 11px 26px !important;
    border-radius: 999px !important;
    font-family: inherit !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 1 !important;
    cursor: pointer;
    transition: filter 0.15s ease, background 0.15s ease, border-color 0.15s ease !important;
  }

  #hs-eu-cookie-confirmation a#hs-eu-confirmation-button {
    background: var(--auth-accent) !important;
    color: #fff !important;
    border: 1px solid var(--auth-accent) !important;
    box-shadow: 0 8px 20px rgba(255, 122, 0, 0.28) !important;
  }

  #hs-eu-cookie-confirmation a#hs-eu-confirmation-button:hover {
    filter: brightness(1.05) !important;
  }

  #hs-eu-cookie-confirmation a#hs-eu-decline-button {
    background: transparent !important;
    color: var(--auth-text-secondary) !important;
    border: 1px solid var(--auth-input-border) !important;
    font-weight: 600 !important;
    box-shadow: none !important;
  }

  #hs-eu-cookie-confirmation a#hs-eu-decline-button:hover {
    background: var(--auth-bg-cream) !important;
    border-color: var(--auth-text-secondary) !important;
    color: var(--auth-text-primary) !important;
  }

  @media (max-width: 600px) {
    #hs-eu-cookie-confirmation #hs-eu-cookie-confirmation-inner {
      padding: 18px 20px !important;
    }
  }
`;

export const Error = styled.div`
  color: var(--segfy-color-red);
  animation: changeLetter 3s linear infinite alternate;
  transition: width 0.25s;
  margin-left: 20px;
  height: 18px;
  max-width: 310px;
`;

export const Loading = styled(CircularProgress)`
    color: var(--segfy-color-orange) !important;
    display: block !important;
    margin-left: auto;
    margin-right: auto;
`;
